import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';

import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore, TReduxActions, TThunkDispatch } from '../../types/redux';
import { buildersLocationsReducer, buildersProjectsReducer, filtersReducer, seoReducer } from '../../reducers/';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    buildersProjects: buildersProjectsReducer,
    buildersLocations: buildersLocationsReducer,
    filters: filtersReducer,
    seo: seoReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
      reducers,
      initialState,
      storeEnchancers,
    );

  return createStore();
}
